<form [formGroup]="moduleFormGroup">
  <dx-text-box formControlName="name" label="Name" labelMode="floating" stylingMode="outlined"></dx-text-box>
  <div class="html-editor-container">
    <div class="secondary-title custom-title">Description*</div>
    <dx-html-editor height="250px" width="100%" formControlName="description" (onContentReady)="onHtmlEditorContentReady($event)">
      <dxo-toolbar>
        <dxi-item name="link"></dxi-item>
      </dxo-toolbar>
    </dx-html-editor>
  </div>
  <h3>Use cases</h3>
  <brd-usecases-form formControlName="useCases"> </brd-usecases-form>
  <h3>Functionalities</h3>
  <brd-functionalities-form formControlName="functionalities"></brd-functionalities-form>
</form>
